import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';

import { tenantKeys } from './tenantKeys';
import { type TenantSettings, tenantSettingsSchema } from './useGetCurrentTenant';

interface UpdateTenantInput {
  name: string;
  description?: string | null;
}

// PATCH /api/v1/tenants/me — updates name/description on the caller's tenant.
// Backend enforces Tenant.Edit; Editor/Viewer roles get 403 (surfaced as toast).
// Successful response carries the updated settings for cache sync.
export function useUpdateCurrentTenant() {
  const queryClient = useQueryClient();

  return useMutation<TenantSettings, Error, UpdateTenantInput>({
    mutationFn: async (input) => {
      const raw = await apiClient.patch('api/v1/tenants/me', { json: input }).json();
      return tenantSettingsSchema.parse(raw);
    },
    onSuccess: (settings) => {
      queryClient.setQueryData(tenantKeys.current(), settings);
    },
  });
}
